import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Steps, Button, Form, Input, Select, Checkbox, Radio, InputNumber, Rate, Slider, Switch, Card, Alert, Layout, Row, Col, Modal, Table } from 'antd';
import { ArrowLeftOutlined, SaveOutlined, LogoutOutlined, UserOutlined, HistoryOutlined } from '@ant-design/icons';
import authService from '../services/authService';
import { getSiteVisitFormsById, getLeadByPhoneNumber, getLeadById, upsertLead, modifyLead, getFieldChoices,getCompanySettings } from '../services/apiService';
import FullPageLoader from '../components/FullPageLoader';
import AppHeader from '../components/Header';
const pageStyles = `
.ant-btn{
height: 45px;
}
 .back-btn {
    background: #5568d3 !important;
    border-color: #5568d3 !important;
    color: #fff !important;
  }

  .back-btn:hover {
    background: #5568d3 !important;
    border-color: #5568d3 !important;
    color: #fff !important;
  }

  .history-btn {
    border-color: #5568d3 !important;
    color: #5568d3 !important;
  }

  .history-btn:hover {
    background: #5568d3 !important;
    border-color: #5568d3 !important;
    color: #fff !important;
  }
    .ant-input{
    height: 45px;
    border: 1px solid #d9d9d9;
    }
    .ant-select{
    height: 45px;
    border: 1px solid #d9d9d9;
    }
    .ant-picker{
    height: 45px;
    border: 1px solid #d9d9d9;
    margin-top: 10px;
    }
    .ant-checkbox-wrapper{
    margin-top: 10px;
    }
    .ant-radio-group{
    margin-top: 10px;
    }
    .ant-switch{
    margin-top: 10px;
    }
    .ant-rate{
    margin-top: 10px;
    }
    .ant-slider{
    margin-top: 10px;
    }
    .ant-form-item-label{
    font-weight: 700;
    font-size: 16px;
    position: relative;
    color:'#444'
    }
  
  
    .ant-input-number-input{
    height: 45px;
    border: 1px solid #d9d9d9;
    widthe: 100%;
    }

   
    .ant-space-compact{
    width: 100%;
    }
    
    /* Custom dropdown styling */
    .ant-select-selection-item {
      background: #f0f2f5 !important;
      border: 1px solid #d9d9d9 !important;
      border-radius: 4px !important;
      color: #333 !important;
    }
    
    .ant-select-selection-item-remove {
      color: #999 !important;
    }
    
    .ant-select-selection-item-remove:hover {
      color: #ff4d4f !important;
    }
    
    /* Custom tag styling for single-value dropdowns */
    .ant-select-multiple .ant-select-selection-item {
      background: #e6f7ff !important;
      border-color: #91d5ff !important;
      color: #0050b3 !important;
    }
    
    /* Dropdown hint styling */
    .ant-select-dropdown .ant-select-item-option-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
`;

const { Content } = Layout;

// Component to handle Select fields with kernel params
const KernelParamsSelect = ({ field, fieldKey, formValues, setFormValues, loadFieldChoices, formatOptions, mode, form, handleFieldChange, dropdownStates, setDropdownOpen, closeDropdownAfterSelection }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      // First, check if field has values/options defined
      const fieldOptions = field.values || field.options || [];
      
      if (fieldOptions.length > 0) {
        // Use field's own options if available
        setOptions(formatOptions(fieldOptions));
      } else {
        // Otherwise, try to load from kernel params
        setLoading(true);
        try {
          const choices = await loadFieldChoices(field.name);
          if (choices && choices.length > 0) {
            setOptions(formatOptions(choices));
          } else {
            console.warn(`No choices found in kernel params for ${field.name}`);
          }
        } catch (error) {
          console.error(`Error loading choices for ${field.name}:`, error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchOptions();
  }, [field.name, field.values, field.options]);

  // Enhanced mode logic to allow custom values only if custom_configuration is true
  const getSelectMode = () => {
    const allowCustomValues = field.custom_configuration === true;
    
    if (mode === 'multiple') {
      return allowCustomValues ? 'multiple' : 'multiple'; // Multiple mode stays the same
    }
    if (mode === 'tags') {
      return 'tags'; // Tags mode always allows custom values
    }
    // For single select, only use 'tags' mode if custom_configuration is true
    return allowCustomValues ? 'tags' : undefined;
  };

  const selectMode = getSelectMode();
  const isSingleCustom = mode === 'single';
  const allowCustomValues = field.custom_configuration === true;
  const isOpen = dropdownStates[fieldKey] || false;

  return (
    <Select
      mode={selectMode}
      showSearch
      allowClear
      loading={loading}
      open={isOpen}
      onDropdownVisibleChange={(open) => setDropdownOpen(fieldKey, open)}
      maxTagCount={isSingleCustom && allowCustomValues ? 1 : undefined} // Limit to 1 tag for single mode with custom values
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      placeholder={field.placeholder || (allowCustomValues ? `Select or type ${field.label || field.name}` : `Select ${field.label || field.name}`)}
      options={options}
      onChange={(val) => {
        // For single mode with custom values, ensure only one value is selected
        if (isSingleCustom && allowCustomValues && Array.isArray(val) && val.length > 1) {
          // Keep only the last selected value
          val = [val[val.length - 1]];
        }
        handleFieldChange(fieldKey, val);
        
        // Close dropdown after selection for single mode
        if (isSingleCustom) {
          closeDropdownAfterSelection(fieldKey);
        }
      }}
      onSelect={() => {
        // Close dropdown when an option is selected (for single modes)
        if (isSingleCustom) {
          closeDropdownAfterSelection(fieldKey);
        }
      }}
      value={formValues[fieldKey]}
      notFoundContent={loading ? 'Loading...' : (allowCustomValues ? 'Type to add custom option' : 'No options available')}
      tokenSeparators={allowCustomValues ? [','] : undefined} // Only allow comma-separated values if custom values are enabled
      dropdownRender={allowCustomValues ? (menu) => (
        <div>
          {menu}
          <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0', color: '#666', fontSize: '12px' }}>
            Tip: Type to add custom values
          </div>
        </div>
      ) : undefined}
    />
  );
};

const FormWizard = () => {
  const { companyId, formId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [user, setUser] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [mobileNumber, setMobileNumber] = useState('');
  const [leadData, setLeadData] = useState(null);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [isLeadCheckStep, setIsLeadCheckStep] = useState(true);
  const [fieldChoicesCache, setFieldChoicesCache] = useState({});
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyRowWithValue,sethistoryRowWithValue] = useState([]);
  const [showAllColumns, setShowAllColumns] = useState(false);
  const [leadSelectionModalVisible, setLeadSelectionModalVisible] = useState(false);
  const [foundLeads, setFoundLeads] = useState([]);
  const [allowDuplicateLeads, setAllowDuplicateLeads] = useState(false);  
  const [projectKey,setProjectKey] = useState('');
  
  // State to manage dropdown open/close states
  const [dropdownStates, setDropdownStates] = useState({});

  const token = authService.getToken();

  // Helper function to manage dropdown states
  const setDropdownOpen = useCallback((fieldKey, isOpen) => {
    setDropdownStates(prev => ({
      ...prev,
      [fieldKey]: isOpen
    }));
  }, []);

  // Helper function to close dropdown after selection
  const closeDropdownAfterSelection = useCallback((fieldKey) => {
    setTimeout(() => {
      setDropdownOpen(fieldKey, false);
    }, 100);
  }, [setDropdownOpen]);

  // Helper function to get the target history row that should be rendered/processed
  const getTargetHistoryRow = useCallback(() => {
    if (!formData?.meta?.dynamic_history_rows || !Array.isArray(formData.meta.dynamic_history_rows) || formData.meta.dynamic_history_rows.length === 0) {
      return null;
    }

    // Function to check if a history row is already populated in lead data
    const isHistoryRowPopulated = (historyRow) => {
      if (!leadData?.lead_fields || !historyRow.fields) {
        return false;
      }

      // Check if any field in this row has data in lead_fields
      return historyRow.fields.some(field => {
        const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
        const leadValue = leadData.lead_fields[fieldKey];
        
        // Consider field populated if it has a non-empty value
        if (Array.isArray(leadValue)) {
          return leadValue.length > 0 && leadValue[0] !== null && leadValue[0] !== undefined && leadValue[0] !== '';
        }
        
        // For date fields, check if it's a valid date string
        if (field.type === 'date' && typeof leadValue === 'string') {
          return leadValue.trim() !== '' && leadValue !== '0000-00-00';
        }
        
        return leadValue !== null && leadValue !== undefined && leadValue !== '';
      });
    };

    // Find the first available (unpopulated) history row
    let targetHistoryRow = null;
    let targetRowIndex = 0;

    for (let i = 0; i < formData.meta.dynamic_history_rows.length; i++) {
      const historyRow = formData.meta.dynamic_history_rows[i];
      const isPopulated = isHistoryRowPopulated(historyRow);
      
      if (!isPopulated) {
        targetHistoryRow = historyRow;
        targetRowIndex = i;
        break;
      }
    }

    // If all rows are populated, use the first row as fallback
    if (!targetHistoryRow && formData.meta.dynamic_history_rows?.length > 0) {
      targetHistoryRow = formData.meta.dynamic_history_rows[0];
      targetRowIndex = 0;
    }

    return targetHistoryRow;
  }, [formData, leadData]);

  // Memoized callback to handle field changes and prevent re-renders
  const handleFieldChange = useCallback((fieldKey, value) => {
    setFormValues(prev => ({ ...prev, [fieldKey]: value }));
    form.setFieldValue(fieldKey, value);
  }, [form]);

  // Group fields according to meta.layout configuration
  const groupFieldsIntoRows = useCallback((fieldsArray) => {
    // Check if layout configuration exists in meta
    const layoutConfig = formData?.meta?.layout;
    
    if (!layoutConfig || !layoutConfig.rows || layoutConfig.rows.length === 0) {
      // Fallback to default layout logic if no layout config
      const rows = [];
      const processedFieldNames = new Set();
      
      // Priority fields that should always be in the first row
      const priorityFieldNames = ['phone', 'name', 'email'];
      const firstRowFields = [];
      
      // Add priority fields to first row if they exist
      fieldsArray.forEach(field => {
        if (priorityFieldNames.includes(field.name)) {
          field._columnCount = 3; // 3 columns in first row
          firstRowFields.push(field);
          processedFieldNames.add(field.name);
        }
      });
      
      // Add first row if we have priority fields
      if (firstRowFields.length > 0) {
        rows.push(firstRowFields);
      }
      
      // Process remaining fields
      return rows;
    }

    // Use layout configuration from meta
    const rows = [];
    const fieldMap = {};
    
    // Create a map of field names to field objects for quick lookup
    fieldsArray.forEach(field => {
      fieldMap[field.name] = field;
    });

    // Priority fields that should always be in the first row
    const priorityFieldNames = ['phone', 'name', 'email'];
    const firstRowFields = [];
    const processedFieldNames = new Set();

    // Add priority fields to first row if they exist
    priorityFieldNames.forEach(fieldName => {
      const field = fieldMap[fieldName];
      if (field) {
        field._columnCount = 3; // 3 columns in first row
        firstRowFields.push(field);
        processedFieldNames.add(fieldName);
      }
    });

    // Add first row if we have priority fields
    if (firstRowFields.length > 0) {
      rows.push(firstRowFields);
    }

    // Sort layout rows by order
    const sortedLayoutRows = [...layoutConfig.rows].sort((a, b) => (a.order || 0) - (b.order || 0));

    // Build rows according to layout configuration (excluding priority fields)
    sortedLayoutRows.forEach(layoutRow => {
      const rowFields = [];
      
      if (layoutRow.fields && Array.isArray(layoutRow.fields)) {
        layoutRow.fields.forEach(fieldName => {
          // Skip if already processed as priority field
          if (processedFieldNames.has(fieldName)) {
            return;
          }
          
          const field = fieldMap[fieldName];
          if (field) {
            // Add column count info to field for responsive layout
            field._columnCount = layoutRow.columnCount || layoutRow.fields.length;
            rowFields.push(field);
            processedFieldNames.add(fieldName);
          }
        });
      }
      
      if (rowFields.length > 0) {
        rows.push(rowFields);
      }
    });

    // Add any remaining fields that weren't in the layout config or priority fields
    const remainingFields = fieldsArray.filter(field => !processedFieldNames.has(field.name));
    if (remainingFields.length > 0) {
      // Group remaining fields in rows of 3
      for (let i = 0; i < remainingFields.length; i += 3) {
        rows.push(remainingFields);
      }
    }

    return rows;
  }, [formData?.meta?.layout]);

  // Handle reassign lead button click
  const handleReassignClick = () => {
    if (selectedLeadId && user?.company_id) {
      const reassignUrl = `/companies/${user.company_id}/lead-reassign`;
      // Open in new tab to preserve current form state
      window.open(reassignUrl, '_blank');
    } else {
      // Fallback navigation if no lead selected
      navigate(`/companies/${companyId}/lead-reassign`);
    }
  };

  // Handle responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch user details
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await authService.getUserDetails();
        // console.log('User details fetched:', userData);
        setUser(userData);
        
        // Log admin token usage
        if (userData && userData.admin_access) {
          // console.log('Using admin token for API calls. Admin user:', userData.email || userData.name);
        }
        
        // Set GRE Users field with current logged-in user
        if (userData && formData && formData.fields) {
          const greField = formData.fields.find(f => f.label === 'GRE Users');
          if (greField) {
            const fieldKey = greField.id || greField.name;
            setFormValues(prev => ({
              ...prev,
              [fieldKey]: userData.email || userData.user_id || userData.id
            }));
            form.setFieldValue(fieldKey, userData.email || userData.user_id || userData.id);
          }
        }
      } catch (err) {
        console.error('Failed to fetch user details', err);
      }
    };
    fetchUser();
  }, [formData, form]);

  // Initialize date fields with current date (run only once when formData loads)
  useEffect(() => {
    if (formData && formData.fields) {
      const currentDate = new Date().toISOString().split('T')[0];
      const dateFields = [];
      
      // Find all date fields in main fields
      formData.fields.forEach(field => {
        if (field.type === 'date') {
          dateFields.push(field);
        }
        // Also check sub_fields
        if (field.sub_fields && Array.isArray(field.sub_fields)) {
          field.sub_fields.forEach(subField => {
            if (subField.type === 'date') {
              dateFields.push(subField);
            }
          });
        }
      });
      
      // Only check the target history row for date fields (not all history rows)
      const targetHistoryRow = getTargetHistoryRow();
      if (targetHistoryRow && targetHistoryRow.fields && Array.isArray(targetHistoryRow.fields)) {
        targetHistoryRow.fields.forEach(field => {
          if (field.type === 'date') {
            dateFields.push(field);
          }
        });
      }
      
      // Initialize all date fields with current date (only once)
      dateFields.forEach(field => {
        const fieldKey = field.leadFieldMapping || field.id || field.name;
        if (fieldKey) {
          setFormValues(prev => ({
            ...prev,
            [fieldKey]: currentDate
          }));
          form.setFieldValue(fieldKey, currentDate);
        }
      });
    }
  }, [formData]); // Remove getTargetHistoryRow from dependencies to avoid re-renders

  // Fetch form data using apiService
  useEffect(() => {
    let mounted = true;

    (async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getSiteVisitFormsById(companyId, formId, token);
        const settings = await getCompanySettings(companyId);
        if (mounted) {
          setFormData(data);
          setProjectKey(settings.duplicate_leads_identifier);
          setAllowDuplicateLeads(settings.allow_duplicate_leads);
          // console.log('Form data fetched:', data);
        }
      } catch (err) {
        console.error('Failed to fetch form data', err);
        if (mounted) {
          setError(err?.message || 'Failed to load form');
        }
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, []);

  // Function to prepare site visit history data with field labels using dynamic_history_rows
  const prepareSiteVisitHistoryData = () => {
    if (!formData?.meta?.dynamic_history_rows || !leadData) {
      // console.log('No dynamic_history_rows or leadData available for history');
      return [];
    }

    const dynamicHistoryRows = formData.meta.dynamic_history_rows;
    const leadFields = leadData.lead_fields || {};
    const historyData = [];
    
    // Get cp_tat_days from formData (could be in meta, settings, or root level)
    const cpTatDays = formData?.meta?.cp_tat_days  || 60; // Default to 30 days if not found
    // console.log('CP TAT Days:', cpTatDays);
    
    // Helper function to calculate remaining days
    const calculateRemainingDays = (siteVisitDate) => {
      // console.log('siteVisitDate',siteVisitDate);
      if (!siteVisitDate) return null;
      
      try {
        // Parse the site visit date
        let visitDate;
        if (typeof siteVisitDate === 'string' && siteVisitDate.includes('T')) {
          visitDate = new Date(siteVisitDate.split('T')[0]);
        } else {
          visitDate = new Date(siteVisitDate);
        }
        
        // Calculate expiry date by adding cp_tat_days
        const expiryDate = new Date(visitDate);
        expiryDate.setDate(expiryDate.getDate() + cpTatDays);
        
        // Calculate remaining days from today
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day
        expiryDate.setHours(0, 0, 0, 0); // Reset time to start of day
        
        const timeDiff = expiryDate.getTime() - today.getTime();
        const remainingDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        // console.log('remainingDays',remainingDays); 
        return {
          remainingDays: remainingDays === undefined ? null : remainingDays,
          expiryDate: expiryDate.toISOString().split('T')[0],
          isExpired: remainingDays < 0,
          isExpiringSoon: remainingDays <= 3 && remainingDays >= 0
        };
      } catch (error) {
        console.error('Error calculating remaining days:', error);
        return null;
      }
    };
    
    dynamicHistoryRows.forEach((historyRow, rowIndex) => {
     // // console.log(`\nProcessing history row ${rowIndex} (${historyRow.name}):`);
      // console.log("historyRow==============",historyRow);
      if (!historyRow.fields || !Array.isArray(historyRow.fields) || historyRow.fields.length ==0) {
      //  // console.log('  No fields in this history row, skipping');
        return;
      }
      
      // Create a data object for this history row
      const rowData = {
        key: historyRow.id || `history-row-${rowIndex}`,
        rowName: historyRow.name || `History ${rowIndex + 1}`,
        fields: {},
        labels: {},
        hasData: false,
        siteVisitDate: null,
        project:null,
        remainingDaysInfo: null
      };
      
      // Process each field in this history row
      historyRow.fields.forEach(field => {
        //// console.log(`  Processing field ${field.name}:`);
        if (!field.leadFieldMapping) {
          // console.log('Field name is undefined, skipping');
          return;
        }

         
        // Helper function to extract meaningful value
        const extractValue = (value) => {
          if (Array.isArray(value) && value.length > 0) {
            return value[0];
          }
          return value;
        };
        
        // Helper function to extract currency value
        const extractCurrencyValue = (value) => {
          if (Array.isArray(value) && value.length > 0) {
            const item = value[0];
            if (typeof item === 'object' && item !== null && item.value !== undefined) {
              return item.value;
            }
            return item;
          } else if (typeof value === 'object' && value !== null && value.value !== undefined) {
            return value.value;
          }
          return value;
        };


        
        // Get the field value from leadFields
        const fieldValue = leadFields[field.leadFieldMapping];

          let processedValue = null;
        if (field.type === 'currency') {
          processedValue = extractCurrencyValue(fieldValue);
        } else if (field.type === 'date') {
          const dateValue = extractValue(fieldValue);
          if (dateValue && typeof dateValue === 'string' && dateValue.includes('T')) {
            processedValue = dateValue.split('T')[0];
            rowData.siteVisitDate = processedValue;
          } else {
            processedValue = dateValue;
            rowData.siteVisitDate = processedValue;
          }
        } else {
          processedValue = extractValue(fieldValue);
        }


        // console.log('Found value',field.name,fieldValue);
        if (fieldValue !== undefined) {
          rowData.fields[field.name] = processedValue;

          if(field.name.toLowerCase().includes('project')){
            rowData.project =processedValue;
          }
          rowData.hasData = true;
          // console.log(`✓ Field ${field.name} has value:`, fieldValue);
        } else {
          rowData.fields[field.name] = '-';
          // console.log(`    ✗ Field ${field.name} has no value`);
        }
        
      });

      // console.log('rowData',rowData);
      
      // Calculate remaining days if we have a site visit date
      if (rowData.siteVisitDate) {
        rowData.date =rowData.siteVisitDate
        rowData.remainingDaysInfo = calculateRemainingDays(rowData.siteVisitDate);
        // console.log(`  Remaining days info for row ${rowIndex}:`, rowData.remainingDaysInfo);
      }else{
        rowData.remainingDaysInfo = '10';
 
      }
      
      // console.log(`  Row ${rowIndex} hasData: ${rowData.hasData}`);
      
      // Only add rows that have at least one meaningful value
      if (rowData.hasData) {
        // Create a flattened structure for table display
        const tableRowData = {
          key: rowData.key,
          rowName: rowData.rowName,
          date: rowData.date,
          projectUnit: rowData.project,
          budget: rowData.budget,
          channelPartner: rowData.channelPartner,
          remainingDaysInfo: rowData.remainingDaysInfo,
          // Store all field data for flexible access
          allFields: rowData.fields,
          labels: {
            date: rowData.dateLabel || 'Date',
            projectUnit: rowData.projectLabel || 'Project',
            budget: rowData.budgetLabel || 'Budget',
            channelPartner: rowData.channelLabel || 'Channel Partner'
          }
        };
        
        // console.log(`  ✓ Adding row ${rowIndex} to history data:`, tableRowData);
        historyData.push(tableRowData);
      } else {
        // console.log(`  ✗ Skipping row ${rowIndex} - no meaningful data`);
      }
    });

    // console.log(`=== FINAL HISTORY DATA: ${historyData.length} rows ===`);
    // console.log(historyData);
    
    return historyData;
  };

  // Function to show site visit history modal
  const showSiteVisitHistory = () => {
    const historyData = prepareSiteVisitHistoryData();
    setHistoryData(historyData);
    setHistoryModalVisible(true);
    setShowAllColumns(false); // Reset to show only 3 columns by default
  };

  // Function to map lead data to form fields
  const mapLeadDataToFormFields = (leadInfo, formFields) => {
    const mappedValues = {};

    //// console.log("Mapped data called", leadInfo, formFields);
    
    if (!leadInfo || !formFields) return mappedValues;
    
    // Helper function to find field in both main fields and sub_fields
    const findFieldByName = (fieldName) => {
      // First check main fields
      let field = formFields.find(f => f.name === fieldName);
      if (field) return field;
      
      // Then check sub_fields of all fields
      for (const mainField of formFields) {
        if (mainField.sub_fields && Array.isArray(mainField.sub_fields)) {
          field = mainField.sub_fields.find(sf => sf.name === fieldName);
          if (field) return field;
        }
      }
      return null;
    };
    
    // Helper function to map a value based on field type
    const mapFieldValue = (field, value) => {
      if (!value) return value;
      
      // Handle currency fields - extract value from currency object
      if (field.type === 'currency') {
        if (Array.isArray(value) && value.length > 0) {
          // Handle array of currency objects: [{"value": 788888.0, "unit": "INR"}]
          const currencyObj = value[0];
          if (currencyObj && typeof currencyObj === 'object' && currencyObj.value !== undefined) {
            // Preserve currency unit in field definition for later use
            if (currencyObj.unit && !field.currency_unit) {
              field.currency_unit = currencyObj.unit;
            }
            //// console.log(`Extracted currency value from array: ${currencyObj.value} ${currencyObj.unit || ''}`);
            return currencyObj.value;
          }
        } else if (typeof value === 'object' && value !== null && value.value !== undefined) {
          // Handle single currency object: {"value": 788888.0, "unit": "INR"}
          // Preserve currency unit in field definition for later use
          if (value.unit && !field.currency_unit) {
            field.currency_unit = value.unit;
          }
          //// console.log(`Extracted currency value from object: ${value.value} ${value.unit || ''}`);
          return value.value;
        }
        // If it's already a number, return as is
        if (typeof value === 'number') {
          //// console.log(`Currency field already has numeric value: ${value}`);
          return value;
        }
      }
      
      // Handle address objects - extract address_line value
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        // Check if this looks like an address object (has address_line property)
        if (value.address_line) {
          return value.address_line;
        }
        // If it's an object but not an address, return as is for other object types
      }
      
      // Handle date/datetime fields first (before general array handling)
      if (field.type === 'date' || field.type === 'datetime') {
        if (Array.isArray(value) && value.length > 0) {
          // Handle array of date strings: ["2025-12-09T00:00:00Z"]
          const dateValue = value[0];
          if (dateValue && typeof dateValue === 'string') {
            // Extract date part from ISO string
            return dateValue.split('T')[0];
          }
          return dateValue;
        } else if (value && typeof value === 'string') {
          // Extract date part from ISO string
          return value.split('T')[0];
        }
        return value;
      }
      
      // Handle address arrays - extract address_line from last address
      if (Array.isArray(value)) {
        // Check if this is an array of address objects
        if (value.length > 0 && typeof value[0] === 'object' && value[0]?.address_line) {
          const lastAddress = value[value.length - 1];
          return lastAddress.address_line;
        }
        
        // Handle other array values (take first element if single item array)
        if (value.length === 1) {
          value = value[0];
        } else if (value.length === 0) {
          return null;
        }
      }
      
      return value;
    };
    
    // Map basic fields (top-level properties)
    const basicFields = ['name', 'email', 'phone', 'state', 'lead_id'];
    basicFields.forEach(fieldName => {
      if (leadInfo[fieldName]) {
        const formField = findFieldByName(fieldName);
        if (formField) {
          const fieldKey = formField.id || formField.name;
          mappedValues[fieldKey] = mapFieldValue(formField, leadInfo[fieldName]);
        }
      }
    });
    
    // Handle phones array
    if (leadInfo.phones && Array.isArray(leadInfo.phones) && leadInfo.phones.length > 0) {
      const phoneValue = leadInfo.phones[0].phone;
      const phoneField = findFieldByName('phone');
      if (phoneField && phoneValue) {
        const fieldKey = phoneField.id || phoneField.name;
        mappedValues[fieldKey] = phoneValue;
      }
    }
    
    // Handle emails array - use last value
    if (leadInfo.emails && Array.isArray(leadInfo.emails) && leadInfo.emails.length > 0) {
      const emailValue = leadInfo.emails[leadInfo.emails.length - 1].email;
      const emailField = findFieldByName('email');
      if (emailField && emailValue) {
        const fieldKey = emailField.id || emailField.name;
        mappedValues[fieldKey] = emailValue;
      }
    }
    
    // Handle source_tags array
    if (leadInfo.source_tags && Array.isArray(leadInfo.source_tags)) {
      const sourceField = findFieldByName('source_tags');
      if (sourceField) {
        const fieldKey = sourceField.id || sourceField.name;
        mappedValues[fieldKey] = leadInfo.source_tags;
      }
    }
    
    
    // Handle assigned_to object for Sales Manager and Sourcing Manager
    if (leadInfo.assigned_to) {
      // Map to Sales Manager field
      const salesManagerField = formFields.find(f => 
        f.name === 'sales_managers'
      );
      if (salesManagerField) {
        const fieldKey = salesManagerField.id || salesManagerField.name;
        // console.log('Sales Manager fieldKey:', fieldKey, 'Field:', salesManagerField);
        
        if (fieldKey && fieldKey !== 'undefined') {
          const assignedValue = leadInfo.assigned_to.id || leadInfo.assigned_to.name;
          // Only assign if we have a valid value
          if (assignedValue && assignedValue !== undefined) {
            mappedValues[fieldKey] = assignedValue;
            // console.log('Mapped sales manager:', fieldKey, '=', assignedValue);
          }
        } else {
          console.warn('Sales Manager field has no valid id or name:', salesManagerField);
        }
      }
  //  // console.log('leadInfo.assigned_to',leadInfo.assigned_to.name);

    }
    
    // Map lead_fields (additional custom fields including sub-fields)
    if (leadInfo.lead_fields && typeof leadInfo.lead_fields === 'object') {
      Object.keys(leadInfo.lead_fields).forEach(leadFieldKey => {
        // Find matching form field by name (including sub-fields)
        const formField = findFieldByName(leadFieldKey);
        if (formField) {
          const fieldKey = formField.id || formField.name;
          const value = leadInfo.lead_fields[leadFieldKey];
          mappedValues[fieldKey] = mapFieldValue(formField, value);
        }
      });
    }
    
    // Map dynamic history fields from meta.dynamic_history_rows
    if (formData?.meta?.dynamic_history_rows && Array.isArray(formData.meta.dynamic_history_rows)) {
      // console.log('=== MAPPING DYNAMIC HISTORY FIELDS ===');
      const historyRowWithValue = [];
      formData.meta.dynamic_history_rows.forEach((historyRow, rowIndex) => {
        if (historyRow.fields && Array.isArray(historyRow.fields)) {
          // console.log(`Processing history row ${rowIndex} (${historyRow.name}):`);
          
          historyRow.fields.forEach(field => {
            const leadFieldKey = field.leadFieldMapping || field.fieldKey || field.id;
            const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
            
            if (leadInfo.lead_fields && leadInfo.lead_fields[leadFieldKey] !== undefined) {
              const value = leadInfo.lead_fields[leadFieldKey];
              const mappedValue = mapFieldValue(field, value);
              
              // console.log(`  Mapping dynamic field "${field.name}": ${leadFieldKey} -> ${fieldKey} = ${mappedValue}`);
              mappedValues[fieldKey] = mappedValue;
            } else {
              mappedValues[fieldKey] = '';
              // console.log('mappedValue',mappedValues);
              // console.log(`  No data found for dynamic field "${field.name}" (${leadFieldKey})`);
            }
          });

           historyRowWithValue.push({
                                ...historyRow,
                                rowIndex                  // 👈 extra key (optional)
                              });
                                            // console.log('historyRow----',historyRow);

        }
        sethistoryRowWithValue(historyRowWithValue);
        // console.log(historyRowWithValue,'historyRow with value');
      });
      // console.log('=== END DYNAMIC HISTORY FIELDS MAPPING ===');
    }
    
    //// console.log('Mapped lead data to form fields:', mappedValues);
    return mappedValues;
  };

  // Function to handle canceling lead selection and return to mobile number entry
  const handleCancelLeadSelection = () => {
    setLeadSelectionModalVisible(false);
    setSubmitting(false);
    setFoundLeads([]);
    // Reload the page to reset to initial state
    window.location.reload();
  };

  // Function to proceed without selecting any lead (only with mobile number)
  const handleProceedWithoutSelection = async () => {
    setLeadSelectionModalVisible(false);
    setSubmitting(true);
    
    try {
      // Clear any previously selected lead_id since we're proceeding without selection
      setSelectedLeadId(null);
      setLeadData(null);
      
      const initialValues = {
        phone: mobileNumber
      };
      
      // Set GRE Users field with current logged-in user
      if (user && formData && formData.fields) {
        const greField = formData.fields.find(f => f.label === 'GRE Users');
        if (greField) {
          const fieldKey = greField.id || greField.name;
          initialValues[fieldKey] = user.email || user.user_id || user.id;
        }
      }
      
      setFormValues(initialValues);
      form.setFieldsValue(initialValues);
      
    } catch (error) {
      console.error("Error proceeding without lead selection:", error);
    } finally {
      setIsLeadCheckStep(false);
      setSubmitting(false);
    }
  };

  // Function to handle lead selection from modal
  const handleLeadSelection = async (selectedLead) => {
    setLeadSelectionModalVisible(false);
    setSubmitting(true);
    
    try {
      const leadId = selectedLead.lead_id;
      // Store the selected lead_id for later use in submission
      setSelectedLeadId(leadId);
      const initialValues = {
        phone: mobileNumber
      };
      // Fetch full lead details using lead_id
      if (leadId) {
        const leadDetailsResponse = await getLeadById(companyId, leadId);
        if (leadDetailsResponse) {
          const leadInfo = leadDetailsResponse;
          // Create userAssignedObject from assigned_to
          let userAssignedObject = null;
          if (leadInfo.assigned_to) {
            userAssignedObject = {
              user_id: leadInfo.assigned_to.id,
              id: leadInfo.assigned_to.id,
              name: leadInfo.assigned_to.name,
              email_id: leadInfo.assigned_to.email || leadInfo.assigned_to.email_id || leadInfo.assigned_to.user_email || '',
              phone_number: leadInfo.assigned_to.user_phone || leadInfo.assigned_to.phone || '',
              tracking_number: leadInfo.assigned_to.tracking_number || ''
            };
          }
          
          // Use mapping function to extract and map all lead fields
          const mappedLeadData = mapLeadDataToFormFields(leadInfo, formData.fields);
          
          // If userAssignedObject exists, use it for manager fields
          if (userAssignedObject) {
            const salesManagerField = formData.fields.find(f => 
              f.name === 'sales_managers' || 
              f.label === 'Sales Manager'
            );
            if (salesManagerField) {
              const fieldKey = salesManagerField.id || salesManagerField.name;
              // console.log('Sales Manager fieldKey (modal selection):', fieldKey, 'Field:', salesManagerField);
              
              if (fieldKey && fieldKey !== 'undefined') {
                const assignedValue = userAssignedObject.email_id || userAssignedObject.name || userAssignedObject.id;
                // Only assign if we have a valid value
                if (assignedValue && assignedValue !== undefined) {
                  mappedLeadData[fieldKey] = assignedValue;
                  // console.log('Mapped sales manager (modal):', fieldKey, '=', assignedValue);
                }
              } else {
                console.warn('Sales Manager field has no valid id or name (modal):', salesManagerField);
              }
            }
          }
          
          // Merge mapped lead data with initial values
          Object.assign(initialValues, mappedLeadData);
          // Store lead data for reference
          setLeadData(leadInfo);
        }
      }
      
      // Set GRE Users field with current logged-in user
      if (user && formData && formData.fields) {
        const greField = formData.fields.find(f => f.label === 'GRE Users');
        if (greField) {
          const fieldKey = greField.id || greField.name;
          initialValues[fieldKey] = user.user_id || user.id;
        }
      }
      
      setFormValues(initialValues);
      form.setFieldsValue(initialValues);
      
    } catch (error) {
      console.error("Error processing selected lead:", error);
    } finally {
      setIsLeadCheckStep(false);
      setSubmitting(false);
    }
  };

  const handleLeadCheck = async () => {
    if (!mobileNumber) {
      alert('Please enter a mobile number to continue.');
      return;
    }

    setSubmitting(true);
    try {
      // Search for lead by phone number
      const searchResponse = await getLeadByPhoneNumber(companyId, mobileNumber);
      // console.log('Lead search response:', searchResponse);

      // Check if multiple leads were found
      if (searchResponse.data && searchResponse.data.length > 1) {
        // Fetch detailed information for each lead
        // Helper function to get project value using first row's projectUnitField from history_field_mappings
        const getProjectValue = (leadDetails) => {
          if (formData?.meta?.history_field_mappings && formData.meta.history_field_mappings.length > 0) {
            const firstMapping = formData.meta.history_field_mappings[0];
            const projectFieldKey = projectKey || firstMapping.projectUnitField;
            
            // console.log('Using projectUnitField from first mapping:', projectFieldKey);
            
            if (projectFieldKey && leadDetails.lead_fields) {
              const projectValue = leadDetails.lead_fields[projectFieldKey];
              // console.log('Project value found:', projectValue);
              
              if (Array.isArray(projectValue) && projectValue.length > 0) {
                return projectValue[0];
              }
              return projectValue || '-';
            }
          }
          
          // Fallback to original logic if no history_field_mappings
          // console.log('Using fallback project_name field');
          return leadDetails.lead_fields?.project_name || 
                 (Array.isArray(leadDetails.lead_fields?.project_name) ? leadDetails.lead_fields.project_name[0] : '-');
        };

        const detailedLeads = await Promise.all(
          searchResponse.data.map(async (lead) => {
            try {
              const leadDetails = await getLeadById(companyId, lead.lead_id);
              return {
                ...lead,
                details: leadDetails,
                phone: leadDetails.phone || (leadDetails.phones && leadDetails.phones[0]?.phone) || mobileNumber,
                name: leadDetails.name || '-',
                project_name: getProjectValue(leadDetails),
                user_assigned_name: leadDetails.assigned_to?.name || '-'
              };
            } catch (error) {
              console.error(`Error fetching details for lead ${lead.lead_id}:`, error);
              return {
                ...lead,
                phone: mobileNumber,
                name: lead.name || '-',
                project_name: '-',
                user_assigned_name: '-'
              };
            }
          })
        );
        
        // Show modal with detailed lead selection
        setFoundLeads(detailedLeads);
        setLeadSelectionModalVisible(true);
        setSubmitting(false);
        return;
      }

      const initialValues = {
        phone: mobileNumber
      };

      // Check if single lead was found in search results
      if (searchResponse.data && searchResponse.data.length === 1) {
        const searchResult = searchResponse.data[0];
        const leadId = searchResult.lead_id;
        
        // Store the selected lead_id for later use in submission
        setSelectedLeadId(leadId);
        
        //// console.log('Lead found with ID:', leadId);
        
        // Fetch full lead details using lead_id
        if (leadId) {
          const leadDetailsResponse = await getLeadById(companyId, leadId);
          //// console.log('Full lead details:', leadDetailsResponse);
          
          if (leadDetailsResponse) {
            const leadInfo = leadDetailsResponse;
            
            // Create userAssignedObject from assigned_to
            let userAssignedObject = null;
            if (leadInfo.assigned_to) {
              userAssignedObject = {
                user_id: leadInfo.assigned_to.id,
                id: leadInfo.assigned_to.id,
                name: leadInfo.assigned_to.name,
                email_id: leadInfo.assigned_to.email || leadInfo.assigned_to.email_id || '',
                phone_number: leadInfo.assigned_to.user_phone || '',
                tracking_number: leadInfo.assigned_to.tracking_number || ''
              };
              // console.log('Created userAssignedObject:', userAssignedObject);
            }
            
            // Use mapping function to extract and map all lead fields
            const mappedLeadData = mapLeadDataToFormFields(leadInfo, formData.fields);
            
            // If userAssignedObject exists, use it for manager fields
            if (userAssignedObject) {
              // Map to Sales Manager field
              const salesManagerField = formData.fields.find(f => 
                f.name === 'sales_managers'
              );
              if (salesManagerField) {
                const fieldKey = salesManagerField.id || salesManagerField.name;
                // console.log('Sales Manager fieldKey (single lead):', fieldKey, 'Field:', salesManagerField);
                
                if (fieldKey && fieldKey !== 'undefined') {
                  const assignedValue =  userAssignedObject.id || userAssignedObject.name;
                  // Only assign if we have a valid value
                  if (assignedValue && assignedValue !== undefined) {
                    mappedLeadData[fieldKey] = assignedValue;
                    // console.log('Mapped sales manager (single):', fieldKey, '=', assignedValue);
                  }
                } else {
                  console.warn('Sales Manager field has no valid id or name (single):', salesManagerField);
                }
              }
            
            }
            
            // Merge mapped lead data with initial values
            Object.assign(initialValues, mappedLeadData);
            
            // Store lead data for reference
            setLeadData(leadInfo);
          }
        }
      } else {
        //// console.log('No existing lead found for this phone number');
        // Clear any previously selected lead_id since no lead was found
        setSelectedLeadId(null);
        setLeadData(null);
      }
      
      // Set GRE Users field with current logged-in user
      if (user && formData && formData.fields) {
        const greField = formData.fields.find(f => f.label === 'GRE Users');
        if (greField) {
          const fieldKey = greField.id || greField.name;
          initialValues[fieldKey] = user.email || user.user_id || user.id;
        }
      }
      
      setFormValues(initialValues);
      form.setFieldsValue(initialValues);
      
    } catch (error) {
      console.error("Error checking lead:", error);
    } finally {
      setIsLeadCheckStep(false);
      setSubmitting(false);
    }
  };

  // Load field choices from kernel params
  const loadFieldChoices = async (fieldName) => {
    // Check if already cached
    if (fieldChoicesCache[fieldName]) {
      return fieldChoicesCache[fieldName];
    }

    try {
      const choices = await getFieldChoices(companyId, fieldName);
      
      // Cache the choices
      setFieldChoicesCache(prev => ({
        ...prev,
        [fieldName]: choices
      }));
      
      return choices;
    } catch (error) {
      console.error(`Failed to load choices for field ${fieldName}:`, error);
      return [];
    }
  };

  // Convert options array to Select options format
  const formatOptions = (options, displayField = 'name', valueField = 'id') => {
    if (!Array.isArray(options)) return [];

    return options.map((opt) => {
      if (typeof opt === 'object' && opt !== null) {
        const display = opt.name || opt.label || opt.email_id || opt.phone_number || JSON.stringify(opt);
        const value = opt.id || opt.user_id || opt.email_id || opt.phone_number || display;

        return {
          label: display,
          value: value,
          data: opt
        };
      }
      return {
        label: opt,
        value: opt
      };
    });
  };

  // Special formatter for sales_managers field - prioritizes user_id over id
  const formatSalesManagerOptions = (options) => {
    if (!Array.isArray(options)) return [];

    return options.map((opt) => {
      if (typeof opt === 'object' && opt !== null) {
        const display = opt.name ||'';
        const value = opt.id || opt.name;

        // Ensure we don't return undefined values
        return {
          label: display || 'Unknown',
          value: value || opt.id || 'unknown',
          data: opt
        };
      }
      // For non-object values, ensure they're not undefined
      const safeValue = opt !== undefined && opt !== null ? opt : 'unknown';
      return {
        label: safeValue,
        value: safeValue
      };
    }).filter(option => option.value !== 'unknown' && option.value !== undefined); // Filter out any remaining undefined values
  };

  // Sort fields by order property
  const sortFieldsByOrder = (fieldsArray) => {
    return fieldsArray.sort((a, b) => {
      const orderA = a.order !== undefined ? parseInt(a.order) : Infinity;
      const orderB = b.order !== undefined ? parseInt(b.order) : Infinity;
      return orderA - orderB;
    });
  };

  // Check if parent field has value to show sub_fields
  const shouldShowSubFields = (field) => {
    const fieldKey = field.id || field.name;
    const fieldValue = formValues[fieldKey];
    
    // Check if field has a value
    if (field.type === 'checkbox' || field.type === 'switch' || field.type === 'toggle') {
      return fieldValue === true;
    }
    
    // For select/dropdown/multiselect/radio, check if value exists
    if (Array.isArray(fieldValue)) {
      return fieldValue.length > 0;
    }
    
    return fieldValue !== undefined && fieldValue !== null && fieldValue !== '';
  };

  // Filter sub-fields based on parent field's selected value
  const getRelevantSubFields = (field) => {
    const fieldKey = field.id || field.name;
    const fieldValue = formValues[fieldKey];
    // console.log('getRelevantSubFields',fieldKey,fieldValue);
    
    if (!field.sub_fields || !Array.isArray(field.sub_fields)) {
      return [];
    }

    // If no value selected, return empty array
    if (!fieldValue || (Array.isArray(fieldValue) && fieldValue.length === 0)) {
      return [];
    }

    // Special filtering only for "Sub Source" field
    const fieldLabel = (field.label || '').toLowerCase();
    const isSubSourceField = fieldLabel === 'sub source';
    // console.log('isSubSourceField',isSubSourceField);
    // For non-Sub Source fields, return all sub-fields
    // if (!isSubSourceField) {
    //   return field.sub_fields;
    // }

    // Get the selected value(s)
    const selectedValues = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
    // Filter sub-fields based on matching criteria (only for Sub Source)
    // Check if sub-field name or label contains the selected value
    const relevantSubFields = field.sub_fields.filter(subField => {
      // Check each selected value
        return selectedValues.some(selectedValue => {
        const selectedStr = String(selectedValue).toLowerCase();
        const subFieldName = (subField.main_field_option_value || '').toLowerCase();
       // const subFieldLabel = (subField.label || '').toLowerCase();
        
        // Match if sub-field name or label contains the selected value
        // or if the selected value is in the sub-field's name
        return subFieldName.includes(selectedStr) || 
               selectedStr.includes(subFieldName.replace(/_/g, ' '));// ||
               //subFieldLabel.includes(selectedStr);
      });
    });

    // Return only matched sub-fields, empty array if nothing matches
    return relevantSubFields;
  };

  // Render field based on type
  const renderField = (field, isSubField = false) => {
    const fieldKey = field.id || field.name;
    const fieldValue = formValues[fieldKey];
    const hasSubFields = field.sub_fields && Array.isArray(field.sub_fields) && field.sub_fields.length > 0;

    const commonProps = {
      name: field.name === 'gre_users' ? field.gre_name_field : fieldKey,
      label: field.label || field.name,
      value:field.label.toLowerCase().includes('date') ? new Date().toISOString().split('T')[0] : fieldValue,
      required: field.required || false,
      readOnly: field.label === 'GRE Users' ? true : false,
      disabled: field.label === 'GRE Users' ? true : false,
      rules: field.required ? [{ required: true, message: `${field.label || field.name} is required` }] : []
    };

    let fieldComponent;

    switch (field.type) {
      case 'text':
      case 'email':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              type={field.type}
              placeholder={field.placeholder || `Enter ${field.label || field.name}`}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
        break;
      case 'phone':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              readOnly={true}
              type={field.type}
              placeholder={field.placeholder || `Enter ${field.label || field.name}`}
              onChange={(e) => setFormValues({ ...formValues, [fieldKey]: e.target.value })}
            />
          </Form.Item>
        );
        break;
      case 'url':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              type={field.type}
              placeholder={field.placeholder || `Enter ${field.label || field.name}`}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
        break;

      case 'textarea':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input.TextArea
              rows={field.rows || 4}
              placeholder={field.placeholder || `Enter ${field.label || field.name}`}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
        break;

      case 'number':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <InputNumber
              style={{ width: '100%' }}
              placeholder={field.placeholder || 'Enter number'}
              onChange={(val) => handleFieldChange(fieldKey, val)}
            />
          </Form.Item>
        );
        break;

      case 'currency':
        const currencySymbol = field.currency_unit || 'INR';
        fieldComponent = (
          <Form.Item {...commonProps}>
            <InputNumber
              style={{ width: '100%', marginTop: '10px' }}
              placeholder={field.placeholder || 'Enter amount'}
              addonBefore={currencySymbol}
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              min={0}
              precision={2}
              onChange={(val) => handleFieldChange(fieldKey, val)}
            />
          </Form.Item>
        );
        break;

      case 'select':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <KernelParamsSelect
              field={field}
              fieldKey={fieldKey}
              formValues={formValues}
              setFormValues={setFormValues}
              loadFieldChoices={loadFieldChoices}
              formatOptions={formatOptions}
              mode="single"
              form={form}
              handleFieldChange={handleFieldChange}
              dropdownStates={dropdownStates}
              setDropdownOpen={setDropdownOpen}
              closeDropdownAfterSelection={closeDropdownAfterSelection}
            />
          </Form.Item>
        );
        break;
      case 'dropdown':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <KernelParamsSelect
              field={field}
              fieldKey={fieldKey}
              formValues={formValues}
              setFormValues={setFormValues}
              loadFieldChoices={loadFieldChoices}
              formatOptions={formatOptions}
              mode="single"
              form={form}
              handleFieldChange={handleFieldChange}
              dropdownStates={dropdownStates}
              setDropdownOpen={setDropdownOpen}
              closeDropdownAfterSelection={closeDropdownAfterSelection}
            />
          </Form.Item>
        );
        break;

      case 'multidropdown':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <KernelParamsSelect
              field={field}
              fieldKey={fieldKey}
              formValues={formValues}
              setFormValues={setFormValues}
              loadFieldChoices={loadFieldChoices}
              formatOptions={formatOptions}
              mode="multiple"
              form={form}
              handleFieldChange={handleFieldChange}
              dropdownStates={dropdownStates}
              setDropdownOpen={setDropdownOpen}
              closeDropdownAfterSelection={closeDropdownAfterSelection}
            />
          </Form.Item>
        );
        break;

      case 'tags':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <KernelParamsSelect
              field={field}
              fieldKey={fieldKey}
              formValues={formValues}
              setFormValues={setFormValues}
              loadFieldChoices={loadFieldChoices}
              formatOptions={formatOptions}
              mode="tags"
              form={form}
              handleFieldChange={handleFieldChange}
              dropdownStates={dropdownStates}
              setDropdownOpen={setDropdownOpen}
              closeDropdownAfterSelection={closeDropdownAfterSelection}
            />
          </Form.Item>
        );
        break;

      case 'object':
        const isGreField = field.label === 'GRE Users';
        //const isSalesManager = field.name === 'sales_managers';
        const issourcingManager = field.name === 'sourcing_managers';
        
        // Completely skip sourcing_managers field - don't render it at all
        if (issourcingManager) {
          fieldComponent = null;
          break;
        }
        
        const greValue = isGreField && user ? (user.name || user.user_id || user.id) : fieldValue;
        const allowCustomValues = !isGreField && field.custom_configuration === true;
        
        fieldComponent = (
          <Form.Item {...commonProps} initialValue={isGreField && user ? greValue : undefined}>
            <Select
              mode={allowCustomValues ? "tags" : undefined} // Only allow custom values if custom_configuration is true and not GRE field
              maxTagCount={allowCustomValues ? 1 : undefined} // Limit to single selection for object fields with custom values
              showSearch
              allowClear={!isGreField}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              placeholder={field.placeholder || (isGreField ? `Select ${field.label || field.name}` : (allowCustomValues ? `Select or type ${field.label || field.name}` : `Select ${field.label || field.name}`))}
              options={field.name === 'sales_managers' ? formatOptions(field.options) : formatOptions(field.options)}
              onChange={(val) => {
                if (allowCustomValues) {
                  // For fields with custom values, handle array conversion
                  if (Array.isArray(val) && val.length > 1) {
                    // Keep only the last selected value
                    val = [val[val.length - 1]];
                  }
                  // Convert back to single value for object fields
                  const finalValue = Array.isArray(val) && val.length > 0 ? val[0] : val;
                  handleFieldChange(fieldKey, finalValue);
                } else {
                  // Regular dropdown behavior
                  handleFieldChange(fieldKey, val);
                }
              }}
              onSelect={(value, option) => {
                // Close dropdown after selection for non-GRE fields
                if (!isGreField) {
                  setTimeout(() => {
                    const selectElement = document.querySelector(`[data-field-key="${fieldKey}"] .ant-select-selector`);
                    if (selectElement) {
                      selectElement.blur();
                    }
                  }, 100);
                }
              }}
              optionLabelProp="label"
              readOnly={isGreField}
              disabled={isGreField}
              value={isGreField ? greValue : (allowCustomValues ? 
                (Array.isArray(fieldValue) ? fieldValue : (fieldValue ? [fieldValue] : [])) : // Array format for tags mode
                fieldValue // Single value for regular mode
              )}
              tokenSeparators={allowCustomValues ? [','] : undefined} // Only allow comma-separated values if custom values are enabled
              dropdownRender={allowCustomValues ? (menu) => (
                <div>
                  {menu}
                  <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0', color: '#666', fontSize: '12px' }}>
                    Tip: Type to add custom values
                  </div>
                </div>
              ) : undefined}
              data-field-key={fieldKey} // Add data attribute for identification
            />
          </Form.Item>
        );
        break;

      case 'checkbox':
        fieldComponent = (
          <Form.Item {...commonProps} valuePropName="checked">
            <Checkbox
              onChange={(e) => handleFieldChange(fieldKey, e.target.checked)}
            >
              {field.label || field.name}
            </Checkbox>
          </Form.Item>
        );
        break;

      case 'radio':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Radio.Group
              options={formatOptions(field.options)}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
        break;

      case 'date':
        const today = new Date().toISOString().split('T')[0];
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              type="date"
              style={{ 
                width: '100%', 
                marginTop: '10px',
                backgroundColor: '#f5f5f5',
                cursor: 'not-allowed'
              }}
              placeholder={field.placeholder || 'Select date'}
              value={today}
              readOnly={true}
              disabled={true}
            />
          </Form.Item>
        );
        break;

      case 'time':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              type="time"
              style={{ width: '100%', marginTop: '10px' }}
              placeholder={field.placeholder || 'Select time'}
              value={fieldValue || ''}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
        break;

      case 'datetime':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              type="datetime-local"
              style={{ width: '100%', marginTop: '10px' }}
              placeholder={field.placeholder || 'Select date and time'}
              value={fieldValue ? fieldValue.replace(' ', 'T').substring(0, 16) : ''}
              readOnly={true}
              onChange={(e) => {
                const newValue = e.target.value ? e.target.value.replace('T', ' ') + ':00' : '';
                handleFieldChange(fieldKey, newValue);
              }}
            />
          </Form.Item>
        );
        break;

      case 'toggle':
      case 'switch':
        fieldComponent = (
          <Form.Item {...commonProps} valuePropName="checked">
            <Switch
              onChange={(checked) => handleFieldChange(fieldKey, checked)}
            />
          </Form.Item>
        );
        break;

      case 'rating':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Rate
              onChange={(val) => handleFieldChange(fieldKey, val)}
            />
          </Form.Item>
        );
        break;

      case 'slider':
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Slider
              min={field.min || 0}
              max={field.max || 100}
              step={field.step || 1}
              onChange={(val) => handleFieldChange(fieldKey, val)}
            />
          </Form.Item>
        );
        break;

      default:
        fieldComponent = (
          <Form.Item {...commonProps}>
            <Input
              placeholder={field.placeholder || `Enter ${field.label || field.name}`}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
            />
          </Form.Item>
        );
    }

    // Return just the field component, sub_fields will be handled separately
    return fieldComponent;
  };

  const handleNext = async () => {
    try {
      await form.validateFields();
      if (currentStep < totalSteps - 1) {
        setCurrentStep(currentStep + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (err) {
      //// console.log('Validation failed');
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubmit = async () => {
    //// console.log('handleSubmit called');
    //// console.log('Current formValues:', formValues);
    
    try {
      // Validate all fields
      const values = await form.validateFields();
      //// console.log('Form validated successfully:', values);
      
      setSubmitting(true);
      
      // Merge form values with validated values
      const allFormValues = { ...formValues, ...values };
      
      // Filter to only include fields that are actually rendered in the current form
      const getRenderedFields = () => {
        const renderedFields = new Set();
        
        // Add main form fields
        if (formData && formData.fields) {
          formData.fields.forEach(field => {
            const fieldKey = field.id || field.name;
            if (fieldKey) {
              renderedFields.add(fieldKey);
            }
            
            // Add sub_fields
            if (field.sub_fields && Array.isArray(field.sub_fields)) {
              field.sub_fields.forEach(subField => {
                const subFieldKey = subField.id || subField.name;
                if (subFieldKey) {
                  renderedFields.add(subFieldKey);
                }
              });
            }
          });
        }
        
        // Add only the target history row fields (not all history rows)
        const targetHistoryRow = getTargetHistoryRow();
        if (targetHistoryRow && targetHistoryRow.fields && Array.isArray(targetHistoryRow.fields)) {
          targetHistoryRow.fields.forEach(field => {
            const fieldKey = field.leadFieldMapping || field.id || field.name;
            if (fieldKey) {
              renderedFields.add(fieldKey);
            }
          });
        }
        
        return renderedFields;
      };
      
      const renderedFields = getRenderedFields();
      
      // Filter allFormValues to only include rendered fields
      const allValues = {};
      Object.keys(allFormValues).forEach(key => {
        if (renderedFields.has(key) || ['name', 'phone', 'email'].includes(key)) {
          allValues[key] = allFormValues[key];
        }
      });
      
      console.log('Filtered form values to only include rendered fields:', Object.keys(allValues));
      
      // Log dynamic history fields for debugging
      if (formData?.meta?.dynamic_history_rows && formData.meta.dynamic_history_rows.length > 0) {
        // console.log('=== DYNAMIC HISTORY FIELDS DEBUG ===');
        
        // Find which row would be used (same logic as in renderDynamicHistoryFields)
        let targetHistoryRow = null;
        let targetRowIndex = 0;

        for (let i = 0; i < formData.meta.dynamic_history_rows.length; i++) {
          const historyRow = formData.meta.dynamic_history_rows[i];
          const isPopulated = historyRow.fields?.some(field => {
            const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
            const leadValue = leadData?.lead_fields?.[fieldKey];
            
            if (Array.isArray(leadValue)) {
              return leadValue.length > 0 && leadValue[0] !== null && leadValue[0] !== undefined && leadValue[0] !== '';
            }
            return leadValue !== null && leadValue !== undefined && leadValue !== '';
          });
          
          if (!isPopulated) {
            targetHistoryRow = historyRow;
            targetRowIndex = i;
            break;
          }
        }

        if (!targetHistoryRow) {
          targetHistoryRow = formData.meta.dynamic_history_rows[formData.meta.dynamic_history_rows.length - 1];
          targetRowIndex = formData.meta.dynamic_history_rows.length - 1;
        }

        // console.log(`Using history row ${targetRowIndex} (${targetHistoryRow.name || `History Row ${targetRowIndex + 1}`}) from dynamic_history_rows[${targetRowIndex}]:`);
        targetHistoryRow.fields?.forEach(field => {
          const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
          const fieldValue = allValues[fieldKey];
          // console.log(`  ${field.name}: ${fieldKey} = ${fieldValue}`);
        });
        // console.log('=====================================');
      }
      
      // Ensure GRE Users field is set with current user
      if (user && formData && formData.fields) {
        const greField = formData.fields.find(f => f.label === 'GRE Users');
        if (greField) {
          const fieldKey = greField.id || greField.name;
          allValues[fieldKey] = user.email || user.user_id || user.id;
        }
      }


      
      // Prepare data for API submission
      const submitData = {
        name: allValues.name,
        phone: allValues.phone || mobileNumber,
        email: allValues.email,
        state: 'site_visit_done',
        ...(formData?.meta?.hidden_fields || {})
      };

      

      // Helper function to find field by key
      const findFieldByKey = (fieldKey) => {
        // Check main fields
        let field = formData.fields.find(f => (f.id || f.name) === fieldKey);
        if (field) return field;
        
        // Check sub_fields
        for (const mainField of formData.fields) {
          if (mainField.sub_fields && Array.isArray(mainField.sub_fields)) {
            field = mainField.sub_fields.find(sf => (sf.id || sf.name) === fieldKey);
            if (field) return field;
          }
        }
        return null;
      };

      // Helper function to check if a date field value is empty
      const isDateFieldEmpty = (dateValue) => {
        if (!dateValue || dateValue === '') {
          return true;
        }
        
        // Handle array format dates
        if (Array.isArray(dateValue)) {
          return dateValue.length === 0 || !dateValue[0] || dateValue[0] === '';
        }
        
        // Handle object format dates
        if (typeof dateValue === 'object' && dateValue !== null) {
          return !dateValue.value || dateValue.value === '';
        }
        
        return false;
      };

      // Helper function to find next available mapping in history_field_mappings
      const getNextAvailableMapping = (forceIndex = null) => {
        if (!formData?.meta?.history_field_mappings) {
          return null;
        }

        const historyMappings = formData.meta.history_field_mappings;

        // If forceIndex is specified, use that mapping
        if (forceIndex !== null && forceIndex >= 0 && forceIndex < historyMappings.length) {
          // console.log('Using forced mapping index:', forceIndex, historyMappings[forceIndex]);
          return historyMappings[forceIndex];
        }

        // If no existing lead data, use first mapping
        if (!leadData?.lead_fields) {
          // console.log('No existing lead data, using first mapping');
          return historyMappings[0] || null;
        }

        const leadFields = leadData.lead_fields || {};

        // Find the first mapping where the dateField is empty (primary indicator of available slot)
        for (let i = 0; i < historyMappings.length; i++) {
          const mapping = historyMappings[i];
          const dateValue = leadFields[mapping.dateField];
          
          // console.log(`Checking mapping ${i}: dateField=${mapping.dateField}, value=`, dateValue);

          // Use helper function to check if date field is empty
          if (isDateFieldEmpty(dateValue)) {
            // console.log('✓ Found next available mapping at index:', i, 'dateField is empty:', mapping.dateField);
             console.log('  Will use keys:', {
              dateField: mapping.dateField,
              projectUnitField: mapping.projectUnitField,
              budgetField: mapping.budgetField,
              channelPartnerField: mapping.channelPartnerField
            });
            return mapping;
          } else {
            // console.log('✗ Mapping', i, 'is occupied, dateField has value:', dateValue);
          }
        }

        // console.log('No empty mapping found, using first mapping as fallback');
        return historyMappings[0] || null;
      };

      // Get the next available mapping for dynamic field assignment
      const nextMapping = getNextAvailableMapping();
      
      if (nextMapping) {
        const mappingIndex = formData.meta.history_field_mappings.indexOf(nextMapping);
        // console.log('=== DYNAMIC FIELD MAPPING ===');
        // console.log('Using mapping index:', mappingIndex);
        // console.log('Mapping details:', nextMapping);
        // console.log('Lead type:', selectedLeadId ? 'Existing Lead' : 'New Lead');
        // console.log('=============================');
      } else {
        // console.log('No mapping available for dynamic field assignment');
      }

      // Helper function to get dynamic field key based on field type and mapping
      const getDynamicFieldKey = (field, originalKey) => {
        if (!nextMapping) {
          return originalKey; // Fallback to original key if no mapping available
        }

        // Map field types to corresponding mapping keys
        if (field && selectedLeadId) {
          const fieldName = (field.name || '').toLowerCase();
          const fieldLabel = (field.label || '').toLowerCase();
          const originalKeyLower = originalKey.toLowerCase();

          // Date fields - check type, name, label, and original key
          if (field.type === 'date' || field.type === 'datetime' || field.type === 'datetime-local' ||
              fieldName.includes('date') || fieldLabel.includes('date') ||
              originalKeyLower.includes('date') || originalKeyLower.includes('visit')) {
            // console.log(`Mapping date field ${originalKey} to ${nextMapping.dateField}`);
            return nextMapping.dateField;
          }

          // Project/Unit fields
          if (fieldName.includes('project') || fieldLabel.includes('project') ||
              fieldName.includes('unit') || fieldLabel.includes('unit') ||
              fieldName.includes('tower') || fieldLabel.includes('tower') ||
              originalKeyLower.includes('project') || originalKeyLower.includes('unit') ||
              originalKeyLower.includes('tower')) {
            // console.log(`Mapping project field ${originalKey} to ${nextMapping.projectUnitField}`);
            return nextMapping.projectUnitField;
          }

          // Budget/Price/Amount fields
          if (field.type === 'currency' || field.type === 'number' ||
              fieldName.includes('budget') || fieldLabel.includes('budget') ||
              fieldName.includes('price') || fieldLabel.includes('price') ||
              fieldName.includes('amount') || fieldLabel.includes('amount') ||
              fieldName.includes('cost') || fieldLabel.includes('cost') ||
              originalKeyLower.includes('budget') || originalKeyLower.includes('price') ||
              originalKeyLower.includes('amount') || originalKeyLower.includes('cost')) {
            // console.log(`Mapping budget field ${originalKey} to ${nextMapping.budgetField}`);
            return nextMapping.budgetField;
          }

          // Channel Partner fields
          if (fieldName.includes('channel') || fieldLabel.includes('channel') ||
              fieldName.includes('partner') || fieldLabel.includes('partner') ||
              fieldName.includes('broker') || fieldLabel.includes('broker') ||
              fieldName.includes('agent') || fieldLabel.includes('agent') ||
              originalKeyLower.includes('channel') || originalKeyLower.includes('partner') ||
              originalKeyLower.includes('broker') || originalKeyLower.includes('agent')) {
            // console.log(`Mapping channel partner field ${originalKey} to ${nextMapping.channelPartnerField}`);
            return nextMapping.channelPartnerField;
          }
        }

        // Return original key if no mapping found
        // console.log(`No dynamic mapping found for field ${originalKey}, using original key`);
        return originalKey;
      };

      // Add all other form fields with proper formatting
      Object.keys(allValues).forEach(key => {
        // Skip if key is undefined, null, or empty
        if (!key || key === 'undefined' || key === 'null' || key === 'name' || key === 'phone' || key === 'email') {
          return;
        }
        
        const field = findFieldByKey(key);
        let value = allValues[key];
        let submitKey = key;
        
        // Skip if value is undefined
        if (value === undefined) {
          console.warn('Skipping field', key, 'with undefined value');
          return;
        }
        
        // Apply dynamic field key mapping based on history_field_mappings
        if (nextMapping) {
          // Apply dynamic mapping for:
          // 1. New leads (!selectedLeadId)
          // 2. Existing leads where we're adding a new visit (nextMapping is not the first mapping)
          const shouldApplyMapping = !selectedLeadId || 
                                   (selectedLeadId && formData?.meta?.history_field_mappings && 
                                    formData.meta.history_field_mappings.indexOf(nextMapping) > 0);
          
          if (shouldApplyMapping) {
            const dynamicKey = getDynamicFieldKey(field, key);
            if (dynamicKey !== key) {
              submitKey = dynamicKey;
               console.log('Applied dynamic mapping:', key, '->', submitKey, 
                         selectedLeadId ? '(new visit to existing lead)' : '(new lead)');
            }
          } else {
            // console.log('Skipping dynamic mapping for existing lead first visit');
          }
        }

        // Change field name from sales_managers to user_assigned_to if field type is object
        if (field && field.type === 'object' && field.name === 'sales_managers') {
          submitKey = 'user_assigned_to';
          // console.log('Changed field name from', key, 'to', submitKey, 'for sales_managers value');
        }
        
        // Skip if submitKey becomes undefined or invalid
        if (!submitKey || submitKey === 'undefined' || submitKey === 'null') {
          console.warn('Skipping field with invalid submitKey:', submitKey);
          return;
        }
          
          // Format currency fields for submission
          if (field && field.type === 'currency' && value !== null && value !== undefined && value !== '') {
            // Convert numeric value back to currency object format
            const currencyValue = typeof value === 'number' ? value : parseFloat(value);
            if (!isNaN(currencyValue)) {
              const currencyUnit = field.currency_unit || 'INR'; // Use field's currency unit or default to INR
              value = [{
                "value": currencyValue,
                "unit": currencyUnit
              }];
              //// console.log(`Formatted currency field ${key}:`, value);
            }
          }
          
          // Handle custom dropdown values (convert single-item arrays back to single values)
          // Only convert arrays if the field has custom_configuration enabled
          if (field && (field.type === 'select' || field.type === 'dropdown' || field.type === 'object') && 
              field.custom_configuration === true && Array.isArray(value) && value.length === 1) {
            // Convert single-item array back to single value for single-select dropdowns with custom values
            value = value[0];
            // console.log(`Converted single-item array to single value for ${key}:`, value);
          }
          
        // Final safety check before adding to submitData
        if (submitKey && submitKey !== 'undefined' && submitKey !== 'null' && value !== undefined) {
          submitData[submitKey] = value;
          // console.log('Added field to submitData:', submitKey, '=', value);
        } else {
          console.warn('Skipped adding field to submitData - submitKey:', submitKey, 'value:', value);
        }
      });

      // Add current date for visit date fields if not already set
      const currentDate = new Date().toISOString().split('T')[0];
      
      // Find date fields and ensure they have values
      if (formData && formData.fields) {
        const dateFields = [];
        
        // Find all date fields in main fields
        formData.fields.forEach(field => {
          if (field.type === 'date') {
            dateFields.push(field);
          }
          // Also check sub_fields
          if (field.sub_fields && Array.isArray(field.sub_fields)) {
            field.sub_fields.forEach(subField => {
              if (subField.type === 'date') {
                dateFields.push(subField);
              }
            });
          }
        });
        
        // Only check the target history row for date fields (not all history rows)
        const targetHistoryRow = getTargetHistoryRow();
        if (targetHistoryRow && targetHistoryRow.fields && Array.isArray(targetHistoryRow.fields)) {
          targetHistoryRow.fields.forEach(field => {
            if (field.type === 'date') {
              dateFields.push(field);
            }
          });
        }
        
        // Ensure all date fields always use current date in submitData
        dateFields.forEach(field => {
          const fieldKey = field.leadFieldMapping || field.id || field.name;
          if (fieldKey) {
            // Always set current date for site visit date fields
            submitData[fieldKey] = currentDate;
            console.log(`Set current date ${currentDate} for field ${fieldKey}`);
          }
        });
      }
      
      // Legacy fallback for hardcoded field - always use current date
      submitData['visit_details_bab.date_598'] = currentDate;

      // Add source_tags if not from existing lead
      if (!submitData.source_tags || submitData.source_tags.length === 0) {
        submitData.source_tags = ['Site Visit Form'];
      }

      // Remove undefined, null, and empty values from payload
      const cleanSubmitData = (obj) => {
        if (obj === null || obj === undefined) return undefined;
        
        if (Array.isArray(obj)) {
          const cleanedArray = obj
            .map(item => cleanSubmitData(item))
            .filter(item => item !== undefined && item !== null && item !== '');
          return cleanedArray.length > 0 ? cleanedArray : undefined;
        }
        
        if (typeof obj === 'object') {
          const cleaned = {};
          Object.entries(obj).forEach(([key, value]) => {
            const cleanedValue = cleanSubmitData(value);
            if (cleanedValue !== undefined && cleanedValue !== null && cleanedValue !== '') {
              cleaned[key] = cleanedValue;
            }
          });
          return Object.keys(cleaned).length > 0 ? cleaned : undefined;
        }
        
        // Return undefined for empty strings, otherwise return the value
        return obj === '' ? undefined : obj;
      };
      
      const cleanedSubmitData = cleanSubmitData(submitData);
      
      //// console.log('Submitting form data:', cleanedSubmitData);
      
      // Check if we have an existing lead_id to modify, otherwise create new lead
      let response;
      if (selectedLeadId) {
        // console.log('Modifying existing lead with ID:', selectedLeadId);
        response = await modifyLead(companyId, selectedLeadId, cleanedSubmitData);
      } else {
        // console.log('Creating new lead');
        response = await upsertLead(companyId, cleanedSubmitData);
      }
      // console.log('API Response:', response);
      
      // Navigate to thank you page
      navigate(`/companies/${companyId}/site_visit_forms/${formId}/thank-you`);
    } catch (err) {
      console.error('Submission failed', err);
      
      // Check if it's a validation error
      if (err.errorFields) {
        console.error('Validation errors:', err.errorFields);
        alert('Please fill in all required fields correctly.');
      } else {
        alert(err?.response?.data?.message || err?.message || 'Failed to submit form');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Reload the page to reset to initial state and go back to mobile number entry
    window.location.reload();
  };

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setDrawerVisible(false);
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      onClick: () => navigate('/')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
      danger: true
    }
  ];

  // Memoize expensive calculations before any early returns
  const formMeta = formData?.meta || {};
  let fields = formData?.fields || [];
  
  // Add default fields at the beginning
  const defaultFields = [];
  
  // Combine default fields with API fields
  fields = [...defaultFields, ...fields];
  
  // Memoize expensive field sorting operation
  const sortedFields = useMemo(() => {
    if (!fields || fields.length === 0) return [];
    return sortFieldsByOrder(fields);
  }, [fields]);
  
  const fieldsPerStep = 50;
  const totalSteps = Math.ceil(sortedFields.length / fieldsPerStep) || 1;
  const currentFields = sortedFields.slice(currentStep * fieldsPerStep, (currentStep + 1) * fieldsPerStep);

  // Memoize expensive field grouping operation
  const organizedRows = useMemo(() => {
    if (!currentFields || currentFields.length === 0) return [];
    return groupFieldsIntoRows(currentFields);
  }, [currentFields, formData?.meta?.layout]);

  if (loading) return <FullPageLoader message="Loading form..." />;

  if (error) {
    return (
      <Alert
        message="Error"
        description={error}
        type="error"
        showIcon
        style={{ margin: 20 }}
      />
    );
  }

  // Function to render dynamic history row fields
  const renderDynamicHistoryFields = () => {
    // console.log('=== RENDER DYNAMIC HISTORY FIELDS DEBUG ===');
    // console.log('formData?.meta?.dynamic_history_rows:', formData?.meta?.dynamic_history_rows);
    
    if (!formData?.meta?.dynamic_history_rows || !Array.isArray(formData.meta.dynamic_history_rows) || formData.meta.dynamic_history_rows.length === 0) {
      // console.log('❌ No dynamic_history_rows found or empty array');
      return null;
    }

    // console.log('✅ Found dynamic_history_rows:', formData.meta.dynamic_history_rows.length, 'rows');

    // Function to check if a history row is already populated in lead data
    const isHistoryRowPopulated = (historyRow) => {
      if (!leadData?.lead_fields || !historyRow.fields) {
        // console.log(`  No lead data or fields for row: ${historyRow.name}`);
        return false;
      }

      // Check if any field in this row has data in lead_fields
      const isPopulated = historyRow.fields.some(field => {
        // Use leadFieldMapping as primary key, fallback to fieldKey or id
        const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
        const leadValue = leadData.lead_fields[fieldKey];
        
        // console.log(`  Checking field "${field.name}" (type: ${field.type}) with key "${fieldKey}": leadValue =`, leadValue);
        
        // Consider field populated if it has a non-empty value
        if (Array.isArray(leadValue)) {
          const hasValue = leadValue.length > 0 && leadValue[0] !== null && leadValue[0] !== undefined && leadValue[0] !== '';
          // console.log(`    Array value populated: ${hasValue} (length: ${leadValue.length})`);
          return hasValue;
        }
        
        // For date fields, check if it's a valid date string
        if (field.type === 'date' && typeof leadValue === 'string') {
          const hasValue = leadValue.trim() !== '' && leadValue !== '0000-00-00';
          // console.log(`    Date value populated: ${hasValue} (value: "${leadValue}")`);
          return hasValue;
        }
        
        const hasValue = leadValue !== null && leadValue !== undefined && leadValue !== '';
        // console.log(`    Single value populated: ${hasValue}`);
        return hasValue;
      });

      // console.log(`  Row "${historyRow.name}" is populated: ${isPopulated}`);
      return isPopulated;
    };

    // Find the first available (unpopulated) history row
    let targetHistoryRow = null;
    let targetRowIndex = 0;

    for (let i = 0; i < formData.meta.dynamic_history_rows.length; i++) {
      const historyRow = formData.meta.dynamic_history_rows[i];
      const isPopulated = isHistoryRowPopulated(historyRow);
      
      // console.log(`Checking history row ${i} (${historyRow.name}): populated = ${isPopulated}`);
      
      if (!isPopulated) {
        targetHistoryRow = historyRow;
        targetRowIndex = i;
        // console.log(`✓ Using history row ${i} (${historyRow.name}) - first available row`);
        break;
      } else {
        // console.log(`✗ History row ${i} (${historyRow.name}) is already populated, checking next row`);
      }
    }

    // If all rows are populated, use the last row as fallback
    if (!targetHistoryRow) {

      if (!targetHistoryRow && formData.meta.dynamic_history_rows?.length > 0) {
        targetHistoryRow = formData.meta.dynamic_history_rows[0];
        targetRowIndex = 0;
      }
      // targetHistoryRow = formData.meta.dynamic_history_rows[formData.meta.dynamic_history_rows.length - 1];
      // targetRowIndex = formData.meta.dynamic_history_rows.length - 1;
      // console.log(`All history rows are populated, using last row ${targetRowIndex} (${targetHistoryRow.name}) as fallback`);
    }

    if (!targetHistoryRow.fields || !Array.isArray(targetHistoryRow.fields)) {
      // console.log('❌ No fields in target history row or not an array');
      return null;
    }

    // console.log('✅ Rendering dynamic history fields from row:', targetRowIndex, targetHistoryRow);

    // Group fields into rows of maximum 3 fields each
    const fieldsPerRow = 3;
    const fieldRows = [];
    
    for (let i = 0; i < targetHistoryRow.fields.length; i += fieldsPerRow) {
      fieldRows.push(targetHistoryRow.fields.slice(i, i + fieldsPerRow));
    }

    // console.log(`Grouped ${targetHistoryRow.fields.length} fields into ${fieldRows.length} rows of max ${fieldsPerRow} fields each`);

    return (
      <div style={{ marginBottom: 16 }}>
        {/* Show which history row is being used */}
        {/* <div style={{ 
          marginBottom: 8, 
          fontSize: '12px', 
          color: '#666',
          fontStyle: 'italic' 
        }}>
          Using {targetHistoryRow.name || `History Row ${targetRowIndex + 1}`} (dynamic_history_rows[{targetRowIndex}])
        </div> */}
        
        {/* Render each row of fields */}
        {fieldRows.map((fieldRow, rowIndex) => (
          <Row key={rowIndex} gutter={[16, 16]} style={{ marginBottom: rowIndex < fieldRows.length - 1 ? 16 : 0 }}>
            {fieldRow.map((field, fieldIndex) => {
              // Use leadFieldMapping as primary key, fallback to fieldKey or id
              const fieldKey = field.leadFieldMapping || field.fieldKey || field.id;
              const fieldValue = formValues[fieldKey];
              
              
              // console.log(`Dynamic field: "${field.name}" (type: ${field.type}) -> key: "${fieldKey}" = value:`, fieldValue);
              
              // Calculate column span - 3 fields per row (8 columns each), mobile full width
              const colSpan = window.innerWidth < 768 ? 24 : 8;

              return (
                <Col key={field.id || `${rowIndex}-${fieldIndex}`} span={colSpan}>
                  <Form.Item
                    name={fieldKey}
                    label={field.name || field.label}
                    required={field.required || false}
                  >
                    {renderDynamicHistoryField(field, fieldKey, fieldValue)}
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        ))}
      </div>
    );
  };

  // Function to render individual dynamic history field based on type
  const renderDynamicHistoryField = (field, fieldKey, fieldValue) => {
    // console.log(`Rendering field "${field.name}" (type: ${field.type}) with options:`, field.dropdownOptions);
    
    switch (field.type) {
      case 'text':
      case 'string':
        return (
          <Input
            placeholder={field.placeholder || `Enter ${field.name || field.label}`}
            value={fieldValue || ''}
            onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
          />
        );
      
      case 'number':
        return (
          <InputNumber
            style={{ width: '100%' }}
            placeholder={field.placeholder || `Enter ${field.name || field.label}`}
            value={fieldValue}
            onChange={(val) => handleFieldChange(fieldKey, val)}
          />
        );
      
      case 'date':
        const today = new Date().toISOString().split('T')[0];
        return (
          <Input
            type="date"
            style={{
              width: '100%',
              height: '45px',
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              padding: '0 12px',
              fontSize: '14px',
              backgroundColor: '#f5f5f5',
              cursor: 'not-allowed'
            }}
            placeholder={field.placeholder || 'Select date'}
            value={today}
            readOnly={true}
            disabled={true}
          />
        );
      
      case 'select':
      case 'dropdown':
        // Format dropdown options properly for Ant Design Select
        const formatDropdownOptions = (options) => {
          if (!Array.isArray(options)) {
            console.warn(`dropdownOptions is not an array for field "${field.name}":`, options);
            return [];
          }
          
          // console.log(`Formatting ${options.length} dropdown options for field "${field.name}"`);
          
          return options.map((option, index) => {
            // If option is already an object with label/value, use it as is
            if (typeof option === 'object' && option !== null && (option.label || option.value)) {
              return {
                label: option.label || option.value,
                value: option.value || option.label
              };
            }
            
            // If option is a string, create label/value object
            if (typeof option === 'string') {
              return {
                label: option,
                value: option
              };
            }
            
            // Fallback for other types
            const stringValue = String(option);
            return {
              label: stringValue,
              value: stringValue
            };
          });
        };

        const formattedOptions = formatDropdownOptions(field.dropdownOptions || []);
        // console.log(`Formatted dropdown options for "${field.name}":`, formattedOptions);

        // Check if custom values are allowed for this field
        const allowCustomValues = field.custom_configuration === true;
        
        // Create a unique key for this dropdown to manage its open state
        const dropdownKey = `${fieldKey}_dropdown`;
        
        return (
          <Select
            key={dropdownKey}
            mode={allowCustomValues ? "tags" : undefined} // Only enable tags mode if custom_configuration is true
            maxTagCount={allowCustomValues ? 1 : undefined} // Limit to single selection for dropdown behavior only if custom values allowed
            placeholder={field.placeholder || (allowCustomValues ? `Select or type ${field.name || field.label}` : `Select ${field.name || field.label}`)}
            value={allowCustomValues ? 
              (Array.isArray(fieldValue) ? fieldValue : (fieldValue ? [fieldValue] : [])) : // Array format for tags mode
              fieldValue // Single value for regular mode
            }
            onChange={(val) => {
              if (allowCustomValues) {
                // For single dropdown with custom values, ensure only one value is selected
                let finalValue = val;
                if (Array.isArray(val) && val.length > 1) {
                  // Keep only the last selected value
                  finalValue = [val[val.length - 1]];
                }
                // Convert back to single value for consistency
                const singleValue = Array.isArray(finalValue) && finalValue.length > 0 ? finalValue[0] : null;
                // console.log(`Dropdown "${field.name}" changed to:`, singleValue);
                handleFieldChange(fieldKey, singleValue);
              } else {
                // Regular dropdown behavior
                handleFieldChange(fieldKey, val);
              }
            }}
            onSelect={(value, option) => {
              // Close dropdown after selection by triggering blur
              setTimeout(() => {
                const selectElement = document.querySelector(`[data-dropdown-key="${dropdownKey}"] .ant-select-selector`);
                if (selectElement) {
                  selectElement.blur();
                }
              }, 100);
            }}
            options={formattedOptions}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            tokenSeparators={allowCustomValues ? [','] : undefined} // Only allow comma-separated values if custom values are enabled
            dropdownRender={allowCustomValues ? (menu) => (
              <div>
                {menu}
                <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0', color: '#666', fontSize: '12px' }}>
                  Tip: Type to add custom values
                </div>
              </div>
            ) : undefined}
            data-dropdown-key={dropdownKey} // Add data attribute for identification
          />
        );
      
      default:
        // console.log(`Using default input for field "${field.name}" with type "${field.type}"`);
        return (
          <Input
            placeholder={field.placeholder || `Enter ${field.name || field.label}`}
            value={fieldValue || ''}
            onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
          />
        );
    }
  };

  
  if (!formData) return <FullPageLoader message="Loading form..." />;
  
  if (isLeadCheckStep) {
    return (
      <>
      <style>{pageStyles}</style>
        <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
           <AppHeader 
          isMobile={isMobile}
          formMeta={formMeta}
          userMenuItems={userMenuItems}
          drawerVisible={drawerVisible}
          setDrawerVisible={setDrawerVisible}
          handleLogout={handleLogout}
          user={user}
          showReassignButton={true}
          onReassignClick={handleReassignClick}
        />
          <Content style={{ padding: isMobile ? 12 : 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Card style={{ width: isMobile ? '100%' : 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
              {formMeta.image?.[0]?.public_url && (
                <img
                  src={formMeta.image[0].public_url}
                  alt="Company Logo"
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    maxHeight: 80,
                    maxWidth: '80%',
                    objectFit: 'contain'
                  }}
                />
              )}
              {!formMeta.image?.[0]?.public_url && (
                <h5 style={{ textAlign: 'center', marginTop: 12, marginBottom: 24 }}>Check Lead</h5>
              )}  
              <Form layout="vertical" onFinish={handleLeadCheck} autoComplete="off">
                <Form.Item
                  label="Mobile Number"
                  name="mobileNumber"
                  rules={[{ required: true, message: 'Please enter a mobile number.' }, { pattern: /^[0-9]{10}$/, message: 'Please enter a valid 10-digit mobile number.' }]}
                >
                  <Input
                    placeholder="Enter 10-digit mobile number"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    maxLength={10}
                  />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={submitting} block style={{ height: 45, background: '#5568d3' }}>
                    {submitting ? 'Checking...' : 'Submit'}
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Content>
        </Layout>
      </>
    );
  }

  return (
    <>
    <style>{pageStyles}</style>
    
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader 
        isMobile={isMobile}
        formMeta={formMeta}
        userMenuItems={userMenuItems}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        handleLogout={handleLogout}
        user={user}
        showReassignButton={true}
        onReassignClick={handleReassignClick}
      />

      <Content style={{ 
        padding: isMobile ? 12 : 24,
        background: '#fff',
        overflow: 'auto'
      }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', elevation: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', padding: isMobile ? 12 : 24, borderRadius: 8, background: '#fff'}}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: isMobile ? 12 : 24,
            flexWrap: 'wrap',
            gap: 8
          }}>
            <Button
              type="text"
              className="back-btn"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(`/companies/${companyId}/site_visit_forms/list`)}
              style={{ paddingLeft: 10 }}
            >
              {!isMobile ? 'Back to Forms' : 'Back'}
            </Button>
            
            
            {formData?.meta?.dynamic_history_rows && leadData && (
              <Button
                type="default"
                className="history-btn"
                icon={<HistoryOutlined />}
                onClick={showSiteVisitHistory}
              >
                {!isMobile ? 'Site Visit History' : 'History'}
              </Button>
            )}
          </div>

          {totalSteps  > 1 && (
          <div style={{ marginBottom: isMobile ? 12 : 24 }}>
            <p style={{ color: '#666', margin: 0, fontSize: isMobile ? 12 : 14 }}>
              Step {currentStep + 1} of {totalSteps}
            </p>
          </div>
        )}

          {totalSteps  > 1 && !isMobile && (
            <Steps
              current={currentStep}
              style={{ marginBottom: 30 }}
              items={Array.from({ length: totalSteps }, (_, i) => ({
                title: `Step ${i + 1}`
              }))}
            />
          )}

          <Card style={{ marginBottom: 24}}>
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
            >

              <div style={{ marginBottom: 24 }}>
                        <h5 style={{ 
                          color: '#333', 
                          borderBottom: '1px solid #333', 
                          paddingBottom: 0 
                        }}>
                    Client Information 
                                           </h5>
                      </div>

              {organizedRows.length > 0 ? (
                organizedRows.map((row, rowIdx) => (
                  <React.Fragment key={rowIdx}>
                    {/* Add Site Visit Details section after first row (priority fields) */}
                    {rowIdx === 2 && (() => {
                    return formData?.meta?.dynamic_history_rows;
                    })() && (
                      <div style={{ marginBottom: 24 }}>
                        <h5 style={{ 
                          color: '#333', 
                          borderBottom: '2px solid #333', 
                          paddingBottom: 0 
                        }}>
                          Site Visit Details
                        </h5>
                        {renderDynamicHistoryFields()}
                      </div>
                    )}
                    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                      {row.map((field, fieldIdx) => {
                        const isMobile = window.innerWidth < 768;
                        
                        // Calculate column span based on layout configuration
                        let colSpan = 8; // default to 1/3 (8 out of 24)
                        
                        if (isMobile) {
                          colSpan = 24; // Full width on mobile
                        } else if (field._columnCount) {
                          // Use column count from layout config
                          colSpan = Math.floor(24 / field._columnCount);
                        } else if (field.layout) {
                          // Fallback to field's layout property
                          const layout = field.layout;
                          colSpan = layout === 'full' ? 24 : (layout === 'onethird' ? 8 : (layout === 'half' ? 12 : 6));
                        }
                      
                        return (
                          <Col key={field.id || fieldIdx} span={colSpan}>
                            {renderField(field)}
                          </Col>
                        );
                      })}
                    </Row>
                    
                    {/* Render sub_fields for each field in this row */}
                    {row.map((field, fieldIdx) => {
                      const hasSubFields = field.sub_fields && Array.isArray(field.sub_fields) && field.sub_fields.length > 0;
                      // console.log("main Fields",field);
                      if (hasSubFields && shouldShowSubFields(field)) {
                        const relevantSubFields = getRelevantSubFields(field);
                        // console.log('relevantSubFields',relevantSubFields);
                        if (relevantSubFields.length === 0) {
                          return null;
                        }
                        
                        return (
                          <div 
                            key={`sub-${field.id || fieldIdx}`}
                            style={{ 
                              marginLeft: 24, 
                              marginTop: 8,
                              marginBottom: 16,
                              paddingLeft: 16,
                              borderLeft: '3px solid #5568d3'
                            }}
                          >
                            <Row gutter={[16, 16]}>
                              {relevantSubFields.map((subField, subIdx) => {
                                const subLayout = subField.layout || 'onethird';
                                const subColSpan = subLayout === 'full' ? 24 : (subLayout === 'onethird' ? 8 : (subLayout === 'half' ? 12 : (window.innerWidth < 768 ? 24 : 6)));
                                
                                return (
                                  <Col key={subField.id || subIdx} span={subColSpan}>
                                    {renderField(subField, true)}
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </React.Fragment>
                ))
              ) : (
                <p>No fields available</p>
              )}
            </Form>
          </Card>

          {totalSteps > 1 && (
          <div style={{ 
            display: 'flex', 
            gap: isMobile ? 8 : 12, 
            justifyContent: 'space-between',
            marginBottom: 24,
            flexWrap: 'wrap'
          }}>
            
            <Button
              onClick={handlePrev}
              disabled={currentStep === 0}
              style={{ minWidth: isMobile ? 'auto' : 100, flex: isMobile ? 1 : 'auto' }}
            >
              {isMobile ? 'Prev' : 'Previous'}
            </Button>

            <div style={{ display: 'flex', gap: isMobile ? 8 : 12, flex: isMobile ? 1 : 'auto' }}>
              {currentStep === totalSteps - 1 ? (
                <>
                  <Button
                    type="default"
                    onClick={handleCancel}
                    style={{ 
                      minWidth: isMobile ? 'auto' : 100,
                      flex: isMobile ? 1 : 'auto',
                      maxWidth:140
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{ 
                      background: '#5568d3', 
                      minWidth: isMobile ? 'auto' : 150,
                      flex: isMobile ? 1 : 'auto',
                      maxWidth:100
                    }}
                  >
                    {submitting ? 'Submitting...' : (isMobile ? 'Submit' : 'Submit Form')}
                  </Button>
                </>
              ) : (
                <Button
                  type="primary"
                  onClick={handleNext}
                  style={{ minWidth: isMobile ? 'auto' : 100, flex: isMobile ? 1 : 'auto' }}
                >
                  {isMobile ? 'Next' : 'Next'}
                </Button>
              )}
            </div>
          </div>
          )
          }
            {
            totalSteps === 1 && (
              <div style={{ 
                marginBottom: 24,
                textAlign: isMobile ? 'center' : '-webkit-center',
                display: 'flex',
                gap: isMobile ? 8 : 12,
                justifyContent: 'center'
              }}>
                <Button
                  type="default"
                  onClick={handleCancel}
                  style={{ 
                    minWidth: isMobile ? 'auto' : 100,
                    flex: isMobile ? 1 : 'auto',
                    maxWidth:140
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  loading={submitting}
                  onClick={handleSubmit}
                  style={{ 
                    background: '#5568d3', 
                    minWidth: isMobile ? 'auto' : 150,
                    flex: isMobile ? 1 : 'auto',
                    alignItems: 'center',
                    maxWidth:100
                  }}
                >
                  {submitting ? 'Submitting...' : (isMobile ? 'Submit' : 'Submit')}
                </Button>
              </div>
            )   
            }

         
        </div>
      </Content>

      {/* Site Visit History Modal */}
      <Modal
        title="Site Visit History"
        open={historyModalVisible}
        onCancel={() => {
          setHistoryModalVisible(false);
          setShowAllColumns(false); // Reset column state when modal is closed
        }}
        footer={[
          <Button key="close" onClick={() => {
            setHistoryModalVisible(false);
            setShowAllColumns(false); // Reset column state when modal is closed
          }}>
            Close
          </Button>
        ]}
        width={isMobile ? '95%' : 1200}
        style={{ top: isMobile ? 20 : 50 }}
      >
        {historyData.length > 0 ? (
          <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ color: '#666', fontSize: '14px' }}>
                Showing {historyData.length} site visit{historyData.length > 1 ? 's' : ''} with data
              </div>
              {/* <Button 
                type="default" 
                size="small"
                onClick={() => setShowAllColumns(!showAllColumns)}
                style={{ 
                  borderColor: '#5568d3',
                  color: '#5568d3'
                }}
              >
                {showAllColumns ? 'Show Less' : 'Show All Columns'}
              </Button> */}
            </div>
            <Table
              dataSource={historyData}
              pagination={false}
              scroll={{ x: isMobile ? 900 : undefined }}
              size={isMobile ? 'small' : 'middle'}
              columns={[
                // Always show first 3 columns: Date, Remaining TAT, and Project
                ...(historyData.some(item => item.date) ? [{
                  title: historyData[0]?.labels?.date || 'Date',
                  dataIndex: 'date',
                  key: 'date',
                  width: isMobile ? 120 : 140,
                  render: (text) => {
                    if (!text) return <span style={{ color: '#ccc' }}>-</span>;
                    // Format date if it's an ISO string
                    if (typeof text === 'string' && text.includes('T')) {
                      return text.split('T')[0];
                    }
                    return text;
                  }
                }] : []),
                ...(historyData.some(item => item.projectUnit) ? [{
                  title: historyData[0]?.labels?.projectUnit || 'Project',
                  dataIndex: 'projectUnit',
                  key: 'projectUnit',
                  width: isMobile ? 150 : 200,
                  render: (text) => (
                    <div style={{ 
                      maxWidth: isMobile ? 120 : 180, 
                      wordWrap: 'break-word',
                      whiteSpace: 'normal',
                      lineHeight: '1.4'
                    }}>
                      {text || <span style={{ color: '#ccc' }}>-</span>}
                    </div>
                  )
                }] : []),
                // Add remaining days column if any history data has remaining days info
                ...(historyData.some(item => item.remainingDaysInfo) ? [{
                  title: 'Remaining TAT (Days)',
                  key: 'remainingDays',
                  width: isMobile ? 120 : 140,
                  render: (_, record) => {
                    if (!record.remainingDaysInfo) return <span style={{ color: '#ccc' }}>-</span>;
                    
                    const { remainingDays, isExpired, isExpiringSoon } = record.remainingDaysInfo;
                    
                    let color = '#52c41a'; // Green for normal
                    let bgColor = '#f6ffed';
                    let text = `${remainingDays} days`;
                    
                    if (isExpired) {
                      color = '#ff4d4f'; // Red for expired
                      bgColor = '#fff2f0';
                      text = `Expired (${Math.abs(remainingDays)} days ago)`;
                    } else if (isExpiringSoon) {
                      color = '#fa8c16'; // Orange for expiring soon
                      bgColor = '#fff7e6';
                      text = `${remainingDays} days left`;
                    }
                    
                    return (
                      <div style={{ 
                        textAlign: 'center',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        backgroundColor: bgColor,
                        border: `1px solid ${color}20`,
                        fontSize: '12px',
                        fontWeight: '500',
                        color: color
                      }}>
                        {text}
                        {(isExpired || isExpiringSoon) && (
                          <div style={{ fontSize: '10px', marginTop: '2px', opacity: 0.8 }}>
                            {isExpired ? '⚠️ Reassign' : '⏰ Urgent'}
                          </div>
                        )}
                      </div>
                    );
                  }
                }] : []),
                // Show additional columns only when showAllColumns is true
                ...(showAllColumns && historyData.some(item => item.budget) ? [{
                  title: historyData[0]?.labels?.budget || 'Budget',
                  dataIndex: 'budget',
                  key: 'budget',
                  width: isMobile ? 120 : 140,
                  render: (text) => {
                    if (!text) return <span style={{ color: '#ccc' }}>-</span>;
                    // Format budget with currency if it's a number
                    if (typeof text === 'number') {
                      return (
                        <span style={{ fontWeight: '500', color: '#52c41a' }}>
                          ₹{text.toLocaleString('en-IN')}
                        </span>
                      );
                    }
                    return text;
                  }
                }] : []),
                ...(showAllColumns && historyData.some(item => item.channelPartner) ? [{
                  title: historyData[0]?.labels?.channelPartner || 'Channel Partner',
                  dataIndex: 'channelPartner',
                  key: 'channelPartner',
                  width: isMobile ? 140 : 160,
                  render: (text) => (
                    <div style={{ 
                      maxWidth: isMobile ? 120 : 140, 
                      wordWrap: 'break-word',
                      whiteSpace: 'normal',
                      lineHeight: '1.4'
                    }}>
                      {text || <span style={{ color: '#ccc' }}>-</span>}
                    </div>
                  )
                }] : []),
                // Add a column for additional fields if any exist (only when showAllColumns is true)
                ...(showAllColumns && historyData.some(item => item.allFields && Object.keys(item.allFields).length > 4) ? [{
                  title: 'Other Details',
                  key: 'otherDetails',
                  width: isMobile ? 150 : 180,
                  render: (_, record) => {
                    if (!record.allFields) return <span style={{ color: '#ccc' }}>-</span>;
                    
                    // Get fields that aren't already displayed in main columns
                    const mainFields = ['date', 'project', 'budget', 'channel'];
                    const otherFields = Object.entries(record.allFields).filter(([key, value]) => {
                      const keyLower = key.toLowerCase();
                      const hasValue = value !== null && value !== undefined && value !== '';
                      const isMainField = mainFields.some(mainField => keyLower.includes(mainField));
                      return hasValue && !isMainField;
                    });
                    
                    if (otherFields.length === 0) {
                      return <span style={{ color: '#ccc' }}>-</span>;
                    }
                    
                    return (
                      <div style={{ fontSize: '12px', lineHeight: '1.3' }}>
                        {otherFields.map(([key, value], index) => (
                          <div key={key} style={{ marginBottom: index < otherFields.length - 1 ? 4 : 0 }}>
                            <span style={{ color: '#666', fontWeight: '500' }}>
                              {record.labels[key] || key}:
                            </span>{' '}
                            <span>{value}</span>
                          </div>
                        ))}
                      </div>
                    );
                  }
                }] : [])
              ]}
              rowClassName={(record, index) => 
                index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
              }
              expandable={{
                expandedRowRender: (record) => (
                  <div style={{ padding: '12px 0', backgroundColor: '#fafafa' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                      {Object.entries(record.allFields || {}).map(([key, value]) => {
                        if (!value) return null;
                        return (
                          <div key={key} style={{ 
                            padding: '8px 12px', 
                            backgroundColor: '#fff', 
                            borderRadius: '4px',
                            border: '1px solid #e8e8e8'
                          }}>
                            <div style={{ fontWeight: '500', color: '#666', fontSize: '12px', marginBottom: '4px' }}>
                              {record.labels[key] || key}
                            </div>
                            <div style={{ color: '#333', fontSize: '14px' }}>
                              {typeof value === 'number' && key.toLowerCase().includes('budget') 
                                ? `₹${value.toLocaleString('en-IN')}`
                                : value
                              }
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ),
                rowExpandable: (record) => record.allFields && Object.keys(record.allFields).length > 0,
              }}
            />
          </div>
        ) : (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            color: '#666'
          }}>
            <HistoryOutlined style={{ fontSize: 48, marginBottom: 16, color: '#d9d9d9' }} />
            <p>No site visit history available</p>
            <p style={{ fontSize: '14px', color: '#999' }}>
              Site visit data will appear here once visits are recorded
            </p>
          </div>
        )}
        
        {/* Add custom styles for table rows */}
        <style jsx>{`
          .table-row-light {
            background-color: #fafafa;
          }
          .table-row-dark {
            background-color: #ffffff;
          }
          .ant-table-tbody > tr:hover > td {
            background-color: #e6f7ff !important;
          }
          .ant-table-expanded-row > td {
            padding: 0 !important;
          }
        `}</style>
      </Modal>

      {/* Lead Selection Modal */}
      <Modal
        title="Multiple Leads Found"
        open={leadSelectionModalVisible}
        onCancel={handleCancelLeadSelection}
        footer={[
          <Button key="cancel" onClick={handleCancelLeadSelection}>
            Cancel
          </Button>,
          <Button 
            key="proceed" 
            type="default"
            onClick={handleProceedWithoutSelection}
            style={{ marginLeft: 8 }}
          >
            Proceed without selection
          </Button>
        ]}
        width={isMobile ? '95%' : 800}
        style={{ top: isMobile ? 20 : 50 }}
      >
        <p style={{ marginBottom: 16 }}>
          Multiple leads found for phone number <strong>{mobileNumber}</strong>. 
          You can either select an existing lead to pre-fill the form, or proceed without selection to create a new entry:
        </p>
        <Table
          dataSource={foundLeads.map((lead, index) => ({ ...lead, key: index }))}
          pagination={false}
          scroll={{ x: isMobile ? 600 : undefined }}
          size={isMobile ? 'small' : 'middle'}
          columns={[
            {
              title: 'Phone',
              dataIndex: 'phone',
              key: 'phone',
              width: isMobile ? 120 : 140,
              render: (text) => text || '-'
            },
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
              width: isMobile ? 120 : 150,
              render: (text) => text || '-'
            },
            {
              title: 'Project Name',
              dataIndex: 'project_name',
              key: 'project_name',
              width: isMobile ? 130 : 160,
              render: (text) => text || '-'
            },
            {
              title: 'Assigned To',
              dataIndex: 'user_assigned_name',
              key: 'user_assigned_name',
              width: isMobile ? 120 : 150,
              render: (text) => text || '-'
            },
            {
              title: 'Action',
              key: 'action',
              width: isMobile ? 80 : 100,
              render: (_, record) => (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => handleLeadSelection(record)}
                  style={{ background: '#5568d3' }}
                >
                  View
                </Button>
              )
            }
          ]}
        />
      </Modal>
    </Layout>
    </>
  );
};

export default FormWizard;
